
import { defineComponent } from "vue";
import api, { User, CompanyList, AuthorityList, RequestParams, Company } from "../../api/backend-api";
import { getHumanDate } from "../../util/luxonDateHelpers"
import { AxiosError } from "axios";
import ErrorBlock from "@/components/ErrorBlock.vue";

interface State {
  msg: string;
  user: User;
  companyList: CompanyList;
  authorityList: AuthorityList;
  errors: AxiosError[];
}

export default defineComponent({
  name: "ReceiverUserForm",
  components: { ErrorBlock },
  mounted() {
    this.$nextTick(() => {
      this.callGetUser();
    });
  },
  data: (): State => {
    let user = {
      Company: { } as Company
    } as User;
    let companyList = { } as CompanyList
    let authorityList = { } as AuthorityList;
    return {
      msg: "User",
      user: user,
      companyList: companyList,
      authorityList: authorityList,
      errors: [],
    };
  },
  methods: {
    getHumanDate,
    callDelete() {
      this.errors = [];
      api
        .deleteUser(this.user.id)
        .then(() => {
          this.$router.push('/receiver/user')
        })
        .catch((error: AxiosError) => {
          this.errors.push(error.response?.data.message);
        });
    },
    callCreate() {
      this.errors = [];
      const saveButton = document.getElementById('save')
      api
        .createUser(this.user)
        .then((response) => {
          response.data.Password = undefined;
          this.user = response.data
          this.$router.push('/receiver/user/'+response.data.id)
          if (saveButton) {
            saveButton.classList.toggle('disabled')
            saveButton.textContent = 'save'
          }
        })
        .catch((error: AxiosError) => {
          this.errors.push(error.response?.data.message);
          if (saveButton) {
            saveButton.classList.toggle('disabled')
            saveButton.textContent = 'create'
          }
        });

    },
    callSave() {
      const saveButton = document.getElementById('save')
      if (saveButton) {
        saveButton.classList.toggle('disabled')
        saveButton.textContent = '...'
      }
      if (this.user.id == ':') {
        this.callCreate();
        return;
      }
      this.errors = [];
      api
        .saveUser(this.user)
        .then((response) => {
          response.data.Password = undefined;
          this.$router.go(0)
        })
        .catch((error: AxiosError) => {
          this.errors.push(error.response?.data.message);
          if (saveButton) {
            saveButton.classList.toggle('disabled')
            saveButton.textContent = 'save'
          }
        });
    },
    callGetUser() {

      let user_id = '';
      if (typeof this.$route.params.slug != 'string') {
        throw new Error("Invalid url");
      }
      user_id = this.$route.params.slug

      if (user_id == ':') {
        let company = { } as Company;
        this.user.id = ':';
        this.user.Company = company;
        this.user.Authority = []
        this.user.Status = 'inactive'
      }

      this.errors = [];
      const params = { Paging: { Limit: 50 } } as RequestParams
      api.getReceiverCompanyList(params)
        .then((response) => {
          this.companyList = response.data;
          if (user_id == ':' && this.companyList.items && this.companyList.items.length > 0) {
            this.user.Company = this.companyList.items[0]
          }
        })
        .catch((error: AxiosError) => {
          this.errors.push(error.response?.data.message);
        });

      api.getAuthorityList()
        .then((response) => {
          this.authorityList = response.data;
        })
        .catch((error: AxiosError) => {
          this.errors.push(error.response?.data.message);
        });

      if (user_id == ':') {
        return;
      }
      api
        .getUser(user_id)
        .then((response) => {
          response.data.Password = undefined;
          this.user = response.data;
        })
        .catch((error: AxiosError) => {
          this.errors.push(error.response?.data.message);
        });
    },
  }
});
